export const or = (p1: boolean, p2: boolean): boolean => p1 || p2;

export const and = (p1: boolean, p2: boolean): boolean => p1 && p2;

export const condition =
    (p: any) =>
    (fn: any) =>
    (...args: Array<any>) =>
        !!p && fn.apply(this, args);
